module.exports = __webpack_public_path__ + "img/figma.1be08a9e.svg";